import { Component, OnInit, Input } from '@angular/core';
import { Room } from '../model/room';
import { Router } from '@angular/router';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Search } from '../model/search';
import { Empresa } from '../model/empresa';
import { MotorService } from '../services/motor.service';
import { AppSettings } from '../const/app.consts';
import { NgxSpinnerService } from 'ngx-spinner';

import * as $ from 'jquery';


@Component({
  selector: 'app-payment',
  templateUrl: './payment.component.html',
  styleUrls: ['./payment.component.css']
})
export class PaymentComponent implements OnInit {
 
  nome_titular: string;

  public empresa: Empresa;
  public room: Room;
  public search: Search;
  public tarifaPernoite: number;
  public form: [];

  constructor(
    private readonly router: Router,
    private readonly httpClient: HttpClient,
    private readonly motorService: MotorService,
    private spinnerService: NgxSpinnerService
  ) { 
    this.motorService.empresaObservable.subscribe(empresa => this.empresa = empresa);
    this.room = this.router.getCurrentNavigation().extras.state.dados.room;
    this.search = this.router.getCurrentNavigation().extras.state.dados.search;
    this.tarifaPernoite = this.router.getCurrentNavigation().extras.state.dados.tarifaPernoite;
    this.form = this.router.getCurrentNavigation().extras.state.dados.form;
    console.log('value',  this.router.getCurrentNavigation().extras.state.dados.form);
  }

  ngOnInit() {
    $(document).ready(function() {
          
      $('.input-cart-number').on('keyup change', function(){
        
        // if ($(this).val().length > 3) {
        if ($(this).val().toString().length > 3) {
          $(this).next().focus();
        }
        
        var card_number = '';
        $('.input-cart-number').each(function(){
          card_number += $(this).val() + ' ';
        })
        
        $('.credit-card-box .number').html(card_number);
      });
      
      $('#card-holder').on('keyup change', function(){
        var card_holder = '';
        card_holder = $(this).val().toString();        
        $('.credit-card-box .card-holder div').html(card_holder);
      });
      
      // $('#card-holder').on('keyup change', function() {
      //   var card_number = '';
      //   card_number = $(this).val().toString();                
      //   $('.credit-card-box .card-holder div').html(card_number);
      // });
      
      $('#card-expiration-month, #card-expiration-year').change(function(){
        var m;
        var y;
        m = $('#card-expiration-month option').index($('#card-expiration-month option:selected'));
        m = (m < 10) ? '0' + m : m;
        y = $('#card-expiration-year').val().toString().substr(2,2);
        $('.card-expiration-date div').html(m + '/' + y);
      })
      
      $('#card-ccv').on('focus', function(){
        $('.credit-card-box').addClass('hover');
      }).on('blur', function(){
        $('.credit-card-box').removeClass('hover');
      }).on('keyup change', function(){
        $('.ccv div').html($(this).val().toString());
      });
      
      
      /*--------------------
       Tile Preview
      --------------------*/
      setTimeout(function(){
        $('#card-ccv').focus().delay(2000).queue(function(){
          $(this).blur().dequeue();
        });
      }, 500);
      
      //identifica qual a bandeira do cartão pelo número
      function getCreditCardType(accountNumber) {
        var result = 'unknown'        
        if (/^5[1-5]/.test(accountNumber)) {
          result = 'mastercard';
        } else if (/^4/.test(accountNumber)) {
          result = 'visa';
        } else if ( /^(5018|5020|5038|6304|6759|676[1-3])/.test(accountNumber)) {
          result = 'maestro';
        }
        return result;
      }
      
      //exibe a bandeira
      $('#card-number').change(function(){
        console.log(getCreditCardType($(this).val()));
      })
    });    
  }

  public sendPayment(form) {
    
    console.log(form.value.nome_hospede);
    console.log(form.value);

    this.spinner();

    const formData = new FormData();
    formData.append('empresa', this.empresa.id.toString());
    formData.append('search', JSON.stringify(this.search));
    formData.append('room', JSON.stringify(this.room));
    formData.append('data', JSON.stringify(form.value));
    return this.httpClient.post<any>(`${AppSettings.API_ENDPOINT}/api/snippet/motor/payment/finish`, formData).subscribe( res => {
      if (res.status != 200) {        
        const dados = {
          room:   this.room,
          search: this.search,
          tarifaPernoite: this.tarifaPernoite,
          form: form.value
        };
        this.router.navigate(["company", this.empresa.token_motor, 'success'], {state: {   
          dados: dados
        }});

      } else {
        const dados = {
          room:   this.room,
          search: this.search,
          tarifaPernoite: this.tarifaPernoite,
          form: form.value
        };
        this.router.navigate(["company", this.empresa.token_motor, 'success'], {state: {   
          dados: dados
      }});
      }
    });

  }    
  spinner(): void {
    this.spinnerService.show();
    setTimeout(() =>{
      this.spinnerService.hide();
    }, 2000);
  }

}
